/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./VList.vue?vue&type=template&id=157ce708"
import script from "./VList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VList.vue?vue&type=style&index=0&id=157ce708&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports